import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PubSubConstants } from '@zlib/config';
import { Credential } from '@zlib/data-access/models/user.model';
import { AuthService } from '@zlib/services/auth.service';
import { PubSubService } from '@zlib/services/pubsub.services';
import { Enterprise } from '../../../lib/data-access/models/enterprise.model';
import { Subscription } from '../../../lib/data-access/models/subscription.model';

import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { NzImageModule } from 'ng-zorro-antd/image';
import { FormsModule } from '@angular/forms';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzInputModule } from 'ng-zorro-antd/input';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
    NzDropDownModule,
    TranslateModule,
    NzImageModule,
    FormsModule,
    NzAvatarModule,
    NzIconModule,
    NzLayoutModule,
    NzInputModule
]
})
export class HeaderComponent implements OnInit {
    search: string;

    isCollapsed = false;
    avatarUrl: string = '';
    isOnline: boolean = true;
    user: Credential;
    subscriptions: Subscription[];
    enterprise: Enterprise;
    constructor(
        private pubsub: PubSubService,
        private router: Router,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.authService.currentUserSubject?.subscribe((res: Credential) => {
            this.user = res || new Credential();
        });

        this.authService.currentSubscriptionsSubject?.subscribe(
            (res: Subscription[]) => {
                this.subscriptions = res?.map((s) => {
                    s.enterprises = s.enterprises.sort((a, b) =>
                        a.name.localeCompare(b.name)
                    );
                    return s;
                });
            }
        );

        this.authService.currentEnterprise?.subscribe((res: Enterprise) => {
            if (res) {
                this.enterprise = res;
            }
        });
    }

    selectEnterprise(sub, item: Enterprise): void {
        return this.authService.selectEnterprise(item);
    }

    onToggleLeftNavigation(): void {
        this.isCollapsed = !this.isCollapsed;
        this.pubsub.$pub(
            PubSubConstants.EVENTS.ON_EXPAND_LEFT_NAV,
            this.isCollapsed
        );
    }

    getNamePrefix(): string {
        const stringArray = this.user.name?.trim().split(/(\s+)/);
        return stringArray
            ? stringArray[stringArray.length - 1]?.toUpperCase().substring(0, 3)
            : '';
    }

    get fullName(): string {
        return this.user.name;
    }

    onLogout(): void {
        this.authService.logout().subscribe(() => {
            this.router.navigate(['/auth/login']);
        });
    }

    payment(): void {
        this.router.navigate(['/enterprise/payment']);
    }

    filtered(enterprises: Enterprise[]): Enterprise[] {
        if (!enterprises) {
            return [];
        }

        if (!this.search?.length) {
            return enterprises;
        }

        const search = this.search.trim().toLowerCase();

        return enterprises.filter(
            (e) =>
                e.vatId.indexOf(search) > -1 ||
                e.name.toLocaleLowerCase().indexOf(search) > -1
        );
    }
}
